<div class="header" mat-dialog-title [class.hidden]="!loaded">
    {{'businessTexts.chooseSignPosition' | translate}}
    <button class="close-btn" matTooltip="{{'businessTexts.close' | translate}}" (click)="closeDialog()">
        <cqes-icon icon="close" class="close-icon"></cqes-icon>
    </button>
</div>

<div class="spinner-container" *ngIf="!loaded">
    <mat-spinner class="content-box"></mat-spinner>
</div>

<mat-dialog-actions [class.hidden]="!loaded">
    <div class="toolbar">
        <div class="navigation">
            <cloud-numbered-pagination *ngIf="pdfLoaded" [index]="currentPage" [totalCount]="getTotalCount()" (page)="pageEvent($event)"></cloud-numbered-pagination>
            <br>
            {{'businessTexts.goTo' | translate}}:
            <input class="page-num" [(ngModel)]="currentPage" type="number" min="1" /> / {{totalPages}}
            <button mat-raised-button color="accent" id="reset" (click)="onReset()">{{'businessTexts.reset' | translate}}</button>
            
        </div>
        <div class="action-buttons">
            <button mat-raised-button color="accent" (click)="closeDialog()">{{'businessTexts.cancel' | translate}}</button>
            <button mat-raised-button color="accent" (click)="onSave()">{{'businessTexts.save' | translate}}</button>
            <br>
            <span class="choose-file" *ngIf="data.files.length > 1">
                <b>{{'businessTexts.chooseFile' | translate}}:</b>
            </span>
            <mat-select class="file-select" [(ngModel)]="currentFileIndex" [compareWith]="objectComparisonFunction" *ngIf="data.files.length > 1" (openedChange)="selectedDataValue($event)">
                <mat-option *ngFor="let option of data.files; index as i" [value]="i" (click)="loadFile(i)">{{option.fileName}}</mat-option>
            </mat-select>
            <div class="name" *ngIf="data.files.length == 1">
                <b>{{'businessTexts.file' | translate}}: </b>  {{getFileName(0)}}
            </div>
        </div>
    </div>
</mat-dialog-actions>

<mat-dialog-content>
    <div class="dialog-contents" [class.hidden]="!loaded">

        <div class="drag-area">
            <div class="wrapper">
                <div class="wrapper-list">
                    <div [style.display]="onDrag ? 'none' : ''" cdkDropList #signersList="cdkDropList"
                        [cdkDropListData]="signers" [cdkDropListConnectedTo]="[signedList]" class="example-list"
                        (cdkDropListDropped)="drop($event)">
                        <div class="example-box" *ngFor="let item of signers" cdkDrag
                            [cdkDragDisabled]="isAlreadyAddedd(item)"
                            (mousedown)="off = { x: $event.offsetX || 0, y: $event.offsetY || 0 }"
                            (cdkDragStarted)="onDrag = true" (cdkDragEnded)="onDrag = false" [cdkDragData]="item"
                            (cdkDragMoved)="moved($event)" matTooltip="{{'businessTexts.dragPosition' | translate}}" [matTooltipPosition]="'right'" [matTooltipDisabled]="isAlreadyAddedd(item)">
                            {{ getLabel(item) }}
                            <div *cdkDragPlaceholder class="field-placeholder"></div>
                        </div>
                    </div>
                    <div class="example-list" [style.display]="!onDrag ? 'none' : ''">
                        <div class="example-box" *ngFor="let item of signers"
                                            cdkDrag
                        [cdkDragDisabled]="isAlreadyAddedd(item)"
                        (mousedown)="off = { x: $event.offsetX || 0, y: $event.offsetY || 0 }"
                        (cdkDragStarted)="onDrag = true" 
                        (cdkDragEnded)="onDrag = false; stopAutoScroll()"
                        (cdkDragMoved)="moved($event)"
                        [cdkDragData]="item"
                        matTooltip="{{'businessTexts.dragPosition' | translate}}" 
                        [matTooltipPosition]="'right'" 
                        [matTooltipDisabled]="isAlreadyAddedd(item)">
                            {{ getLabel(item) }}
                        </div>
                    </div>
                </div>
                <div class="canvas">
                    <div id="area" class="box">
                        <pdf-viewer id="pdf-viewer" class="box" [src]="pdfSrc" [render-text]="true"
                            [original-size]="true" [(page)]="currentPage" [show-all]="false" style="height: 1135px"
                            (after-load-complete)="onPdfLoad($event)"
                            (page-rendered)="onPageLoaded($event)"></pdf-viewer>
                    </div>
                    <div class="box overlay" [style.width.px]="width" [style.height.px]="height" id="drag-zone">
                        <div cdkDropList #signedList="cdkDropList" [cdkDropListData]="signed" class="drag-zone"
                            cdkDropListSortingDisabled="true" (cdkDropListDropped)="drop($event)">
                            <ng-container *ngFor="let item of signed">
                                <div cdkDrag class="item-box" [style.top.px]="item.y" [style.left.px]="item.x"
                                    *ngIf="item.page == currentPage" [style.z-index]="item['z-index']"
                                    (cdkDragStarted)="changeZIndex(item)"
                                    (cdkDragMoved)="moved($event)"
                                    (cdkDragEnded)="stopAutoScroll()"
                                    (cdkDragDropped)="changePosition($event, item)">
                                    {{ getLabel(item) }}
                                    <button class="action-button" matTooltip="{{'businessTexts.alignX' | translate}}" *ngIf="hasCloseXSnap(item)"
                                        (click)="snapX(item)">
                                        <cqes-icon icon="swap_horiz"></cqes-icon>
                                    </button>
                                    <button class="action-button" matTooltip="{{'businessTexts.alignY' | translate}}" *ngIf="hasCloseYSnap(item)"
                                        (click)="snapY(item)">
                                        <cqes-icon icon="swap_vert"></cqes-icon>
                                    </button>
                                    <button class="action-button" matTooltip="{{'businessTexts.remove' | translate}}"
                                        (click)="removeSignature(item)">
                                        <cqes-icon icon="close" class="close-icon"></cqes-icon>
                                    </button>
                                    <div *cdkDragPlaceholder class="field-placeholder"></div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
            <!-- This is temporary to check values on screen -->
            <!-- <div class="wrapper">
                <pre>{{ signed | json }}
              </pre>
            </div> -->
        </div>
    </div>

</mat-dialog-content>